import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './router/Router';
import { Provider } from 'react-redux';
import store from './store/store';
import { ThemeProvider, createTheme } from '@mui/material/styles';
// import reportWebVitals from './plugins/web-vitals/reportWebVitals';

import '@fontsource/public-sans'; // Defaults to weight 400
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/700.css';
import LoadingOverlay from './components/common/LoadingOverlay';

const theme = createTheme({
  palette: {
    success: {
      main: '#39B54A',
			contrastText: '#fff',
    },
  },
	components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: '0px 8px 16px 0px #3366FF36',
					borderRadius: '8px',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<Provider store={store}>
				<LoadingOverlay />
				<Router />
			</Provider>
		</ThemeProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
